/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

/**
 * The transaction type
 * @nullable
 */
export type AccountTransactionType =
  (typeof AccountTransactionType)[keyof typeof AccountTransactionType] | null

export const AccountTransactionType = {
  AccountDebit: "AccountDebit",
  AccountCredit: "AccountCredit",
  Bill: "Bill",
  Credit: "Credit",
  Deposit: "Deposit",
  Payment: "Payment",
  Repayment: "Repayment",
  WriteOff: "WriteOff",
  DunningCharge: "DunningCharge",
  IncomingBalanceTransfer: "IncomingBalanceTransfer",
  OutgoingBalanceTransfer: "OutgoingBalanceTransfer",
  CreditWriteOff: "CreditWriteOff",
  PaygTransfer: "PaygTransfer",
  WriteOn: "WriteOn",
} as const
